//
// Helper functions for Task Management
//

import { TaskAssignedUser } from "../../Models/TaskManagement/TaskManagementDataModel";

export const getAssignedTeamMemberName = (assignedTeamMember: TaskAssignedUser | undefined) => {
    if (!assignedTeamMember) {
        return "";
    }

    if (assignedTeamMember.firstName.trim() === "" && assignedTeamMember.lastName === "") {
        return assignedTeamMember.emailId;
    }

    return`${assignedTeamMember.firstName} ${assignedTeamMember.lastName.substring(0, 1)}`.trim();
}
